import { create } from 'zustand'

export interface DialogState<T = unknown> {
  open: boolean
  data?: T | null
}

interface DialogStore {
  state: Record<string, DialogState>
  setState: (id: string, open: boolean, data?: unknown) => void
}

export const useDialogStore = create<DialogStore>((set) => ({
  state: {},
  setState: (id, open, data) => {
    set((state) => {
      const newState = {
        ...state.state,
      }

      if (newState[id]) {
        newState[id].open = open
        if (data !== undefined) {
          newState[id].data = data
        }
      } else {
        newState[id] = { open, data }
      }

      return {
        state: newState,
      }
    })
  },
}))
